import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#empty-pseudo}
 */
export class Empty extends PseudoClassSelector {
    static of() {
        return new Empty();
    }
    constructor() {
        super("empty");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element.children().isEmpty();
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Empty) {
    Empty.parse = PseudoClassSelector.parseNonFunctional("empty", Empty.of);
})(Empty || (Empty = {}));
//# sourceMappingURL=empty.js.map